(function () {
  try {
    var root = document.querySelector('[data-section-type="product"]');
    if (!root) return;

    function formatMoneyInRs(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, 'Rs. {{amount}}').replace('INR','Rs.');
      }
      var rupees = (cents / 100).toFixed(2);
      var parts = rupees.split('.');
      var intPart = parts[0]; var decPart = parts[1];
      var lastThree = intPart.substring(intPart.length - 3);
      var otherNumbers = intPart.substring(0, intPart.length - 3);
      if (otherNumbers !== '') lastThree = ',' + lastThree;
      var formattedInt = otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g,",") + lastThree;
      return 'Rs. ' + formattedInt + '.' + decPart;
    }

    function getCartSectionIds() {
      var ids = [];
      document.querySelectorAll('[id^="shopify-section-"]').forEach(function(el){
        var id = el.id.replace('shopify-section-','');
        if (/cart[-_]?drawer/i.test(id)||/cart[-_]?icon/i.test(id)||/mini[-_]?cart/i.test(id)||/header/i.test(id)) ids.push(id);
      });
      return ids;
    }

    function updateCartSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(function(key){
        var container = document.getElementById('shopify-section-'+key);
        if (!container) return;
        var temp = document.createElement('div');
        temp.innerHTML = sections[key];
        var newEl = temp.querySelector('#shopify-section-'+key) || temp.firstElementChild;
        if (newEl) container.replaceWith(newEl);
      });
    }

    function openCartDrawer() {
      var cd = document.querySelector('cart-drawer, mini-cart, side-cart, quick-cart-drawer');
      if (cd && typeof cd.open === 'function') { cd.open(); return true; }
      if (window.cartDrawer && typeof window.cartDrawer.open === 'function') { window.cartDrawer.open(); return true; }
      var drawerToggleEl = document.querySelector('#CartDrawer, .cart-drawer, [data-cart-drawer], .drawer--cart, #sidebar-cart, .mini-cart');
      if (drawerToggleEl) { drawerToggleEl.classList.add('active','is-open','open','drawer--open','is-visible','show'); drawerToggleEl.setAttribute('aria-hidden','false'); return true; }
      var cartIcon = document.querySelector('a[href="/cart"], button[aria-controls="CartDrawer"], .header__icon--cart, [data-action="open-drawer"]');
      if (cartIcon) { cartIcon.click(); return true; }
      return false;
    }

    window.openAndRefreshCart = function(sectionsFromResponse) {
      if (sectionsFromResponse) updateCartSections(sectionsFromResponse);
      var opened = openCartDrawer();
      fetch('/cart.js').then(function(res){return res.json();}).then(function(cart){
        document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
      }).catch(function(){});
      if (!opened) window.location.href = '/cart';
    };

    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var now = new Date();
    var date1 = new Date(now.getTime());
    var dateNext1 = new Date(now.getTime()+86400000);
    var dateNext2 = new Date(now.getTime()+172800000);
    var date3 = new Date(now.getTime()+259200000);
    var date7 = new Date(now.getTime()+604800000);

    var elD1 = root.querySelector('[data-mp-date-1]');
    var elD2 = root.querySelector('[data-mp-date-2]');
    var elD3 = root.querySelector('[data-mp-date-3]');
    if (elD1) elD1.textContent = months[date1.getMonth()]+' '+date1.getDate();
    if (elD2) elD2.textContent = months[dateNext1.getMonth()]+' '+dateNext1.getDate()+' – '+months[dateNext2.getMonth()]+' '+dateNext2.getDate();
    if (elD3) elD3.textContent = months[date3.getMonth()]+' '+date3.getDate()+' – '+months[date7.getMonth()]+' '+date7.getDate();

    var timelineEl = root.querySelector('[data-mp-timeline]');
    if (timelineEl) {
      var lineFill = timelineEl.querySelector('[data-mp-line-fill]');
      var node1 = timelineEl.querySelector('[data-node="1"]');
      var node2 = timelineEl.querySelector('[data-node="2"]');
      var node3 = timelineEl.querySelector('[data-node="3"]');
      function animateTimeline() {
        if (!lineFill) return;
        lineFill.style.transition = 'none'; lineFill.style.width = '0%';
        [node1,node2,node3].forEach(function(n){ if(n) n.classList.remove('is-active','is-zooming'); });
        setTimeout(function(){
          lineFill.style.transition='width 0.8s ease-out'; lineFill.style.width='15%';
          setTimeout(function(){ if(node1) node1.classList.add('is-active','is-zooming'); },800);
          setTimeout(function(){
            lineFill.style.transition='width 1.2s ease-in-out'; lineFill.style.width='50%';
            setTimeout(function(){ if(node2) node2.classList.add('is-active','is-zooming'); },1200);
          },1800);
          setTimeout(function(){
            lineFill.style.transition='width 1.2s ease-in-out'; lineFill.style.width='85%';
            setTimeout(function(){
              if(node3) node3.classList.add('is-active','is-zooming');
              setTimeout(function(){ lineFill.style.transition='width 0.8s ease-out'; lineFill.style.width='100%'; },800);
            },1200);
          },3800);
          setTimeout(function(){ animateTimeline(); },8800);
        },100);
      }
      animateTimeline();
    }

    var variantIdInput = root.querySelector('[data-mp-variant-id]');
    var priceMainEl = root.querySelector('[data-mp-price]');
    var priceCompareEl = root.querySelector('[data-mp-compare]');
    var priceSavingsEl = root.querySelector('[data-mp-savings]');
    var buyNowBtn = root.querySelector('[data-mp-buy-now]');
    var addToCartBtn = root.querySelector('[data-mp-add-to-cart]');
    var qtyInput = root.querySelector('[data-mp-qty-input]');
    var qtyMinus = root.querySelector('[data-mp-qty-minus]');
    var qtyPlus = root.querySelector('[data-mp-qty-plus]');

    var atcDefaultHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg> Add to Cart';

    function resetButtonStates() {
      if (buyNowBtn) { buyNowBtn.disabled=false; buyNowBtn.innerHTML='BUY IT NOW'; }
      if (addToCartBtn) { addToCartBtn.disabled=false; addToCartBtn.innerHTML=atcDefaultHTML; }
      var stickyBuyBtn = root.querySelector('[data-mp-sticky-buy-now]');
      var stickyAddToCartBtn = root.querySelector('[data-mp-sticky-add-to-cart]');
      if (stickyBuyBtn) { stickyBuyBtn.disabled=false; stickyBuyBtn.innerHTML='BUY IT NOW'; }
      if (stickyAddToCartBtn) { stickyAddToCartBtn.disabled=false; stickyAddToCartBtn.innerHTML='Add to Cart'; }
    }
    window.addEventListener('pageshow', resetButtonStates);

    function updatePricesFromCard(card) {
      if (!card) card = root.querySelector('[data-mp-variant-card].is-selected');
      if (!card) return;
      var rawPrice = parseInt(card.dataset.variantPrice,10)||0;
      var rawCompare = card.dataset.variantComparePrice ? parseInt(card.dataset.variantComparePrice,10) : 0;
      var formatted = formatMoneyInRs(rawPrice);
      if (priceMainEl) priceMainEl.textContent = formatted;

      if (priceCompareEl) {
        if (rawCompare > rawPrice) { priceCompareEl.textContent=formatMoneyInRs(rawCompare); priceCompareEl.style.display=''; }
        else priceCompareEl.style.display='none';
      }

      if (priceSavingsEl) {
        if (rawCompare > rawPrice) { priceSavingsEl.textContent='Save '+Math.round((rawCompare-rawPrice)*100/rawCompare)+'%'; priceSavingsEl.style.display=''; }
        else priceSavingsEl.style.display='none';
      }
    }

    function syncQuantity(val) {
      var v = parseInt(val, 10);
      if (isNaN(v) || v < 1) v = 1;
      if (qtyInput) qtyInput.value = v;
      var stickyQtyInput = root.querySelector('[data-mp-sticky-qty-input]');
      if (stickyQtyInput) stickyQtyInput.value = v;
      updatePricesFromCard();
    }

    if (qtyInput) {
      if (qtyMinus) qtyMinus.addEventListener('click', function(){ syncQuantity((parseInt(qtyInput.value,10)||1) - 1); });
      if (qtyPlus) qtyPlus.addEventListener('click', function(){ syncQuantity((parseInt(qtyInput.value,10)||1) + 1); });
      qtyInput.addEventListener('change', function(){ syncQuantity(qtyInput.value); });
    }

    function handleAddToCart(btn) {
      if (!btn || btn.disabled) return;
      var variantId = variantIdInput ? variantIdInput.value : '';
      var qty = qtyInput ? (parseInt(qtyInput.value,10)||1) : 1;
      btn.disabled=true; btn.innerHTML='Adding…';
      var sectionIds = getCartSectionIds();
      var payload = { items:[{id:variantId,quantity:qty}] };
      if (sectionIds.length) { payload.sections=sectionIds.join(','); payload.sections_url=window.location.pathname; }
      
      fetch('/cart/add.js',{ 
        method:'POST', 
        headers:{'Content-Type':'application/json',Accept:'application/json'}, 
        body:JSON.stringify(payload) 
      })
        .then(function(res){ if(!res.ok) throw new Error('add failed'); return res.json(); })
        .then(function(data){ btn.innerHTML='Added!'; resetButtonStates(); window.openAndRefreshCart(data.sections); })
        .catch(function(){ resetButtonStates(); window.location.href='/cart'; });
    }

    if (addToCartBtn) {
      addToCartBtn.addEventListener('click',function(e){ e.preventDefault(); handleAddToCart(addToCartBtn); });
    }

    function handleBuyNow(e) {
      if (e) e.preventDefault();
      var variantId = variantIdInput ? variantIdInput.value : '';
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      if (buyNowBtn) { buyNowBtn.disabled = true; buyNowBtn.innerHTML = 'Processing…'; }
      window.location.href = '/cart/' + variantId + ':' + qty;
    }

    if (buyNowBtn) buyNowBtn.addEventListener('click', handleBuyNow);

    root.querySelectorAll('[data-mp-variant-card]').forEach(function(card){
      card.addEventListener('click',function(){
        if(card.disabled) return;
        root.querySelectorAll('[data-mp-variant-card]').forEach(function(c){c.classList.remove('is-selected');});
        card.classList.add('is-selected');

        var id = card.dataset.variantId;
        if(variantIdInput) variantIdInput.value = id;

        updatePricesFromCard(card);
        var slider = root.querySelector('[data-mp-slider]');
        var image = card.dataset.variantImage;
        if(slider && image){
          root.querySelectorAll('.mp__gallery-slide').forEach(function(slide,idx){
            var img = slide.querySelector('img');
            if(img && img.src && img.src.indexOf(image)!==-1) slider.scrollTo({left:idx*slider.offsetWidth,behavior:'smooth'});
          });
        }
        var isAvailable = !card.classList.contains('is-unavailable');
        if(buyNowBtn) buyNowBtn.disabled=!isAvailable;
        if(addToCartBtn) addToCartBtn.disabled=!isAvailable;

        /* DISPATCH EVENT FOR STICKY BAR SYNC */
        document.dispatchEvent(new CustomEvent('mp:variant-changed', { detail: { card: card } }));
      });
    });
  } catch(err){ console.error('mp-main script error:',err); }
})();